var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.16,
    height: 28.084,
    viewBox: "0 0 29.16 28.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shopping-cart-fill-svgrepo-com",
    d: "M37.143,22.673,35.5,31.7a3.238,3.238,0,0,1-3.188,2.66H16.658l.589,3.24H31.76a3.242,3.242,0,1,1-3.054,2.16H20.774a3.24,3.24,0,1,1-5.516-1.023L11.517,18.16H9.08a1.08,1.08,0,1,1,0-2.16h2.437a2.159,2.159,0,0,1,2.125,1.774L14.3,21.4H36.08a1.08,1.08,0,0,1,1.063,1.273Z",
    transform: "translate(-8 -16)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/ShoppingCart.b58dd83430811fa954225f465ecc6c50.svg";
export { ForwardRef as ReactComponent };